<template>
  <div :class="$style.badgeContainer">
    <StatusBadge
      :class="$style.badge"
      :data-test-id="badgeTestId"
      :status="badgeStatus"
      :text="badgeText"
    />
    <div :class="$style.label">
      {{ label }}
      <ButtonLink
        v-if="shouldShowEnableButton"
        :class="$style.linkText"
        :data-test-id="enableNowTestId"
        text="Enable Now"
        @click="handleOpenEnableModal"
      />
    </div>
    <component
      :is="modalComponentName"
      v-if="!!modalComponentName"
      :showModal="showModal"
      @close-modal="handleCloseEnableModal"
    />
  </div>
</template>

<script>
import { ButtonLink, StatusBadge } from '@jumpcloud/ui-components';
import EnablePushModal from 'client/MFA/modals/EnablePushModal.vue';
import EnableTotpModal from 'client/MFA/modals/EnableTotpModal.vue';
import EnableWebAuthnModal from 'client/MFA/modals/EnableWebAuthnModal.vue';

const mfaLabels = {
  push: 'JumpCloud Protect Mobile Push',
  totp: 'Time-based One Time Password (TOTP)',
  webauthn: 'WebAuthn',
  duo: 'Duo Security',
};

const mfaModalComponents = {
  push: 'EnablePushModal',
  totp: 'EnableTotpModal',
  webauthn: 'EnableWebAuthnModal',
};

export default {
  name: 'MfaStatusIndicator',

  components: {
    ButtonLink,
    EnablePushModal,
    EnableTotpModal,
    EnableWebAuthnModal,
    StatusBadge,
  },

  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      showModal: false,
    };
  },

  computed: {
    badgeStatus() {
      return this.isEnabled ? 'success' : 'inactive';
    },

    badgeTestId() {
      return `${this.type}Badge`;
    },

    badgeText() {
      return this.isEnabled ? 'Enabled' : 'Disabled';
    },

    enableNowTestId() {
      return `${this.type}EnableNow`;
    },

    isEnabled() {
      return this.value.enabled;
    },

    label() {
      return mfaLabels[this.type] || '';
    },

    modalComponentName() {
      return mfaModalComponents[this.type];
    },

    shouldShowEnableButton() {
      return !this.isEnabled && this.type !== 'duo';
    },

    type() {
      return this.value.type;
    },
  },

  methods: {
    handleCloseEnableModal() {
      this.showModal = false;
    },
    handleOpenEnableModal() {
      this.showModal = true;
    },
  },
};
</script>

<style module>
.badgeContainer {
  display: grid;
  grid-gap: var(--jc-spacer-small);
  grid-template-columns: auto 1fr;
  margin: var(--jc-spacer);
}

.badge {
  margin-bottom: auto;
  margin-top: auto;
}

.badgeDisabled {
  color: var(--jc-color-disabled-text);
}

.linkText {
  margin-left: var(--jc-spacer-small);
}
</style>
